import { Modal, Form, Button } from 'antd';
import { useStoreActions, useStoreState } from '../../store';
import { createUseStyles } from 'react-jss';
import { EditPackagingSetForm } from './EditPackagingSetForm';

const useStyles = createUseStyles({
  modal: {},
  formContainer: {
    margin: '30px 15px 30px 15px',
  },
  avatar: {
    marginLeft: '40%',
    background: '#000',
  },
});

export const MODAL_KEY = 'editPackagingSetModalV2';
export const EditPackagingSetModal = () => {
  const open = useStoreState((state) => state.navigation.modals[MODAL_KEY]?.open);
  const activePartnerPackagingSet = useStoreState((state) => state.navigation.modals[MODAL_KEY]?.params);
  const closeModal = useStoreActions((actions) => actions.navigation.toggleModal);
  const addPackagingToSet = useStoreActions((action) => action.packagingV2.addPackagingToSet);
  const deletePackagingFromSet = useStoreActions((action) => action.packagingV2.deletePackagingFromSet);

  const classes = useStyles();
  const [form] = Form.useForm();

  const handleCancelClick = () => {
    form.resetFields();
    closeModal({ key: MODAL_KEY, open: false, params: undefined });
  };

  const handleSubmit = (event: any) => {
    form.validateFields().then(async () => {
      const values = form.getFieldsValue();
      const toDelete = activePartnerPackagingSet?.packagingIds.filter(
        (packagingId: string) => !values.packagingIds.includes(packagingId),
      );
      const toAdd = values.packagingIds.filter(
        (packagingId: string) => !activePartnerPackagingSet?.packagingIds.includes(packagingId),
      );
      for (const pckg of toDelete) {
        await deletePackagingFromSet({ packagingSetId: activePartnerPackagingSet?.packagingSetId, packagingId: pckg });
      }
      for (const pckg of toAdd) {
        await addPackagingToSet({ packagingSetId: activePartnerPackagingSet?.packagingSetId, packagingId: pckg });
      }
      form.resetFields();
      closeModal({ key: MODAL_KEY, open: false, params: undefined });
    });
  };

  const footer = [
    <Button key={'cancel'} onClick={handleCancelClick}>
      Cancel
    </Button>,
    <Button key={'submit'} type="primary" onClick={handleSubmit}>
      Submit
    </Button>,
  ];

  return (
    <Modal
      title={'Edit Packaging Set'}
      className={classes.modal}
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancelClick}
      footer={footer}
    >
      <EditPackagingSetForm form={form} activePartnerPackagingSet={activePartnerPackagingSet} />
    </Modal>
  );
};
